import Routes from 'constants/Routes';
import { Outlet } from 'react-router-dom';
import AdSubMenu, { SubMenuTitle } from '../InternalDeliveryGroup/components/AdSubMenu';

const EkonomiPage = () => (
  <>
    <AdSubMenu
      items={[
        { label: <SubMenuTitle>Prislistor</SubMenuTitle>, path: Routes.ekonomi.priceLists },
      ]}
    />
    <Outlet />
  </>
);
export default EkonomiPage;
